import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { GLOBAL_CONFIG } from '../../data/globalConfig';
import { HttpClient } from '@angular/common/http';
import {  map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LdapService {

  private backendInfra = GLOBAL_CONFIG.config.backendHost;

  constructor(
    private http: HttpClient
  ) { }
  
  search(pattern: string): Observable<string[]> {

    const url = this.backendInfra + '/users/search/' + encodeURIComponent(pattern);

    return this.http.post<any>(url, {}).pipe(
        map(data => {
          const ssr = data.map(dt => dt.user.name);
          return ssr;
        })
    );

}
}
